<template>
  <div
    class="delegation"
    :class="direction"
    :style="{ width: width, '--mixtmt_mixvw': cssDynamicObj.mixvw }"
  >
    <div class="img_box" :style="{ width: logoWidth, height: logoHeight }">
      <img v-if="countryImg" :src="countryImg" alt="" />
      <span v-else class="defaultTeamLogo"></span>
    </div>
    <template
      v-if="themetype === 'A' && playerInfos && playerInfos.length === 1"
    >
      <span
        class="country_name"
        v-text="`${countryName} - ${playerInfos[0].playerName}`"
      ></span>
    </template>
    <template
      v-else-if="themetype === 'D' && playerInfos && playerInfos.length === 2"
    >
      <span
        class="country_name"
        v-text="
          `${countryName} - ${playerInfos[0].playerName}&${playerInfos[1].playerName}`
        "
      ></span>
    </template>
    <template v-else-if="themetype === 'T'">
      <span class="country_name" v-text="countryName"></span>
    </template>
  </div>
</template>

<script>
// 球员信息
export default {
  props: {
    // 必传参数，国家图片
    countryImg: {
      type: String,
      default: '',
    },
    // 必传参数，国家中文名
    countryName: {
      type: String,
      default: '中国',
    },
    width: {
      type: String,
      default: 'calc(10vw * var(--mixtmt_mixvw))',
    },
    logoWidth: {
      type: String,
      default: 'calc(6.667vw * var(--mixtmt_mixvw))',
    },
    logoHeight: {
      type: String,
      default: 'calc(6.667vw * var(--mixtmt_mixvw))',
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
    direction: {
      type: String,
      default: 'left',
    },
    themetype: {
      type: String,
      default: 'T',
    },
    playerInfos: {
      type: [null, Array],
      default: null,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.delegation {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  width: calc(10vw * var(--mixtmt_mixvw));
  &.right {
    flex-direction: row-reverse;
    .country_name {
      padding-right: calc(1.0416vw * var(--mixtmt_mixvw));
      text-align: right;
    }
  }
  .img_box {
    position: relative;
    width: 100%;
    /* height: 6.667vw; */
    &::before {
      content: '\20';
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      border: 1px solid var(--mixtmt_greyColor5);
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .defaultTeamLogo {
      display: block;
      width: 100%;
      height: 100%;
      background-color: var(--mixtmt_greyColor7);
    }
  }
  .country_name {
    flex: 1;
    padding-left: calc(1.0416vw * var(--mixtmt_mixvw));
    font-size: calc(1.11vw * var(--mixtmt_mixvw));
    color: var(--mixtmt_greyColor_main);
    line-height: calc(1.666vw * var(--mixtmt_mixvw));
    text-align: left;
  }
}
</style>
